import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  TemplateRef,
} from '@angular/core';
import { PortalOutletComponentData } from './types';

@Component({
  selector: 'app-portal-outlet-component',
  template: `
    <ng-container *ngTemplateOutlet="content; context:{payload: context}"></ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntPortalTemplateWrapComponent<T, C> {
  @Input() content: TemplateRef<T> | null = null;
  @Input() position: PortalOutletComponentData | null = null;
  @Input() context: C | null = null;

  @HostBinding('style.top') top = '';
  @HostBinding('style.left') left = '';
  @HostBinding('style.width') width = '';

  constructor() {
    this.top = this.position?.top || '';
    this.left = this.position?.left || '';
    this.width = this.position?.width || '';
  }
}
